import { useEffect, useCallback } from 'react';

export default function useKeyDown<T extends HTMLElement>(
  element: T,
  keyCode: string,
  onPress: () => void,
) {
  const keyDownHandler = useCallback(
    (e: KeyboardEvent) => {
      if (e.code === keyCode) {
        onPress();
      }
    },
    [keyCode, onPress],
  );

  useEffect(() => {
    if (!element) return () => null;
    element.addEventListener('keydown', keyDownHandler, false);
    return () => {
      element.removeEventListener('keydown', keyDownHandler, false);
    };
  }, [element, keyDownHandler]);
}
